import axios from "axios";
import { useAppSelector } from "../store";
const user = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user") || "") : null;
let userToken = user?.token;
//let userToken = user?.user?.token;

export const httpNotification = axios.create({
    baseURL: process.env.REACT_APP_NOTIFICATIONAPI_URL,
    headers : {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "application/json",
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Credentials": true
    }
});
export const httpAttachments = axios.create({
    baseURL: process.env.REACT_APP_NOTIFICATIONAPI_URL,
    headers : {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "multipart/form-data",
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Credentials": true
    }
});

export const GETNotification = (action: any) => {
    return httpNotification.get(action);
};
export const POSTNotification = (action: any, data: any) => {
    return httpNotification.post(action, data);
};
export const POSTNotificationAttachments = (action: any, data: any) => {
    return httpAttachments.post(action, data);
};
export const PATCHNotification = (action: any, data: any) => {
    return httpNotification.patch(action, data);
};
export const PUTNotification = (action: any, data: any) => {
    return httpNotification.put(action, data);
};
export const DELETENotification = (action: any) => {
    return httpNotification.delete(action);
}
